export default{
  getSearchSchool: (state) => state.searchSchool,
}



// WEBPACK FOOTER //
// ./src/components/schools/store/getters.js